import React from "react";
import { BEGIN_TIME_STRING, END_TIME_STRING } from "../../../utils";
import "./TemporalValue.scss";

const TempTimelineWrap = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const { children, ...other } = props;
  return (
    <div
      data-temporal-value-part="bar-view-wrapper"
      {...other}
    >
      {children}
    </div>
  );
};

const Segment = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const { children, ...other } = props;
  return (
    <div
      data-temporal-value-part="bar-view-segment"
      {...other}
    >
      {children}
    </div>
  );
};

export const TemporalBarView = ({
  value,
  title,
  usePercentageWidth,
  onClick,
}: { value: any; title?: string; usePercentageWidth?: boolean; onClick?: (e: React.MouseEvent) => void }) => {
  const ranges = value?.temporal?.ranges || [];

  const { totalSeconds, entries } = React.useMemo(() => {
    return ranges.reduce(
      (acc: any, it: any) => {
        const diffInSeconds =
          it.r.start === BEGIN_TIME_STRING || it.r.end === END_TIME_STRING
            ? -1
            : (new Date(it.r.end).getTime() - new Date(it.r.start).getTime()) / 1000;
        return {
          totalSeconds: diffInSeconds === -1 ? acc.totalSeconds : acc.totalSeconds + diffInSeconds,
          entries: acc.entries.concat({ ...it, diffInSeconds }),
        };
      },
      { totalSeconds: 0, entries: [] as any[] },
    );
  }, [ranges]);

  const jsx = React.useMemo(() => {
    return entries.reduce(
      (a: any, it: any, i: number, arr: any[]) => {
        const width = (() => {
          if (it.r.start === BEGIN_TIME_STRING && it.r.end === END_TIME_STRING) return "100%";
          if (
            (it.r.start === BEGIN_TIME_STRING && arr[i + 1]?.r.end === END_TIME_STRING) ||
            (it.r.end === END_TIME_STRING && arr[i - 1]?.r.start === BEGIN_TIME_STRING)
          )
            return "50%";
          if (it.diffInSeconds === -1) return usePercentageWidth ? "2%" : "2%";
          const percent = Math.max(it.diffInSeconds, 1) / totalSeconds;
          return usePercentageWidth ? `${percent * 96}%` : `${percent * 96}%`;
        })();

        const { attrs, count } = (() => {
          const v = it.v;
          const defaultRtrn = { attrs: { "data-value": String(v) } as Record<string, any>, count: a.count };
          switch (v) {
            case false:
              return { ...defaultRtrn };
            case true:
              return { ...defaultRtrn };
            case undefined:
              return { ...defaultRtrn };
            case "Not Valid":
            case null:
              return { ...defaultRtrn };
            default: {
              const nextCount = a.count + 1;
              return { attrs: { "data-shade": String(nextCount % 3) }, count: nextCount };
            }
          }
        })();

        return {
          count,
          jsxArr: a.jsxArr.concat(
            <Segment
              key={`${String(it.v)}_${i}`}
              {...attrs}
              data-start={it.r.start}
              data-end={it.r.end}
              data-title={title}
              style={{ width }}
            />,
          ),
        };
      },
      { count: 0, jsxArr: [] as React.ReactElement[] },
    ).jsxArr;
  }, [entries, totalSeconds, usePercentageWidth, title]);

  return <TempTimelineWrap onClick={onClick}>{jsx}</TempTimelineWrap>;
};

export default TemporalBarView;
